var analytics = {};
var vwdata = window.vwdata = window.vwdata || [];

analytics.VWBasic_Pageload = {
  eventInfo: {
    eventAction: "VWBasic_Pageload",
    pageName: "Car Cover",
    pageCategory: "STRING",
  },
  environment: {
    applicationId: "Car Cover",
    language: "ISO639-1",
    country: "ISO3166 ALPHA2",
  },
  user: {
      browserResolutionHeight: 'STRING',
      browserResolutionWidth: 'STRING',
  }
};
analytics.VWBasic_ContentSection_EnterViewport = {
  eventInfo: {
      eventAction: 'VWBasic_ContentSection_EnterViewport',
      pageName: 'STRING',
      contentId: 'STRING',
      contentLabels: 'OBJECT',
      pageCategory: 'STRING',
      sectionName: 'STRING',
      templateType: 'STRING'
  },
  environment: {
      applicationId: 'STRING',
      featureAppId: 'STRING',
      language: 'ISO639-1',
      country: 'ISO3166 ALPHA2'
  },
  user: {
      browserResolutionHeight: 'STRING',
      browserResolutionWidth: 'STRING',
  }
};
analytics.VWBasic_Anchor_Click = {
  eventInfo: {
      eventAction: 'VWBasic_Anchor_Click',
      pageId: 'STRING',
      pageName: 'STRING',
      pageCategory: 'STRING',
      sectionName: 'STRING',
      templateType: 'STRING'
  },
  environment: {
      applicationId: 'STRING',
      language: 'ISO639-1',
      country: 'ISO3166 ALPHA2'
  },
  link: {
      url: 'STRING',
      name: 'STRING'
  }
};
analytics.VWBasic_Button_Click = {
  eventInfo: {
      eventAction: 'VWBasic_Button_Click',
      pageId: 'STRING',
      pageName: 'STRING',
      contentId: 'STRING',
      pageCategory: 'STRING',
      sectionName: 'STRING',
      templateType: 'STRING'
  },
  environment: {
      applicationId: 'STRING',
      featureAppId: 'STRING',
      featureAppIdAppVersion: 'STRING',
      language: 'ISO639-1',
      country: 'ISO3166 ALPHA2'
  },
  link: {
      url: 'STRING',
      name: 'STRING'
  }
};
analytics.VWBasic_Link_Click = {
  eventInfo: {
      eventAction: 'VWBasic_Link_Click',
      pageId: 'STRING',
      pageName: 'STRING',
      contentId: 'STRING',
      pageCategory: 'STRING',
      sectionName: 'STRING',
      templateType: 'STRING',
      brand: 'STRING'
  },
  environment: {
      applicationId: 'STRING',
      featureAppId: 'STRING',
      featureAppIdAppVersion: 'STRING',
      language: 'ISO639-1',
      country: 'ISO3166 ALPHA2'
  },
  link: {
      url: 'STRING',
      name: 'STRING'
  },
};

export default vwdata;